import script from "./Login.vue?vue&type=script&setup=true&lang=js"
export * from "./Login.vue?vue&type=script&setup=true&lang=js"

import "./Login.vue?vue&type=style&index=0&id=a68fca06&lang=less&scoped=true"

import exportComponent from "D:\\aj项目\\code\\清洁能源英文预登记\\ceec_-visitor_-en\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-a68fca06"]])

export default __exports__